export default "https://cdn-static.gokick.com/assets/0488227f5b7e53bbf90738be35137ce008cd4a94/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";